import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Confirmation } from '../confirmation/confirmation';
import { TFunction } from 'i18next';

type LegalProps = {
    className?: string;
    onApproveClick?: Function;
};

function getlegalMessage(t: TFunction) {
    return (
        <div>
            {t('by_clicking')}{' '}
            <a style={{ whiteSpace: 'nowrap' }} href={t('privacy_link')}>
                {t('privacy_policy')}
            </a>
            {t('and')}
            <a style={{ whiteSpace: 'nowrap' }} href={t('terms_link')}>
                {t('terms_and_conditions')}
            </a>
        </div>
    );
}

export const Legal = (initial: LegalProps) => {
    // eslint-disable-next-line
    const { t, i18n } = useTranslation('legal');
    const [legalProps] = useState<LegalProps | null>(initial);

    if (legalProps === null) return null;

    return (
        <Confirmation
            title={t('user_agreement')}
            onApproveClick={legalProps.onApproveClick}
            message={getlegalMessage(t)}
        />
    );
};
